/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PostAusPostDamagedFormInput = {|
  attachments: $ReadOnlyArray<?any>,
  caseNumber: string,
  costOfGoods: string,
  invoiceNumber: string,
  purchaseDate: string,
  receivedDate: string,
  trackingNumber: string,
|};
export type PostAusPostDamagedFormMutationVariables = {|
  input: PostAusPostDamagedFormInput
|};
export type PostAusPostDamagedFormMutationResponse = {|
  +postAusPostDamagedForm: ?{|
    +result: ?boolean
  |}
|};
export type PostAusPostDamagedFormMutation = {|
  variables: PostAusPostDamagedFormMutationVariables,
  response: PostAusPostDamagedFormMutationResponse,
|};
*/


/*
mutation PostAusPostDamagedFormMutation(
  $input: PostAusPostDamagedFormInput!
) {
  postAusPostDamagedForm(input: $input) {
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PostAusPostDamagedFormPayload",
    "kind": "LinkedField",
    "name": "postAusPostDamagedForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostAusPostDamagedFormMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostAusPostDamagedFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "68642813b3ca3a38eb1a662e7e5507cd",
    "id": null,
    "metadata": {},
    "name": "PostAusPostDamagedFormMutation",
    "operationKind": "mutation",
    "text": "mutation PostAusPostDamagedFormMutation(\n  $input: PostAusPostDamagedFormInput!\n) {\n  postAusPostDamagedForm(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c7c186bf39d7d8c3898aa13e42e30b0a';

module.exports = node;
